export const ERROR_MESSAGE_TRUE = 'Please contact the customer support team in case you want to change the details'